<section id="hero" class="scroll-mt-24">
  <app-projects-hero></app-projects-hero>
</section>

<section id="projects-grid" class="scroll-mt-24">
  <app-projects-grid></app-projects-grid>
</section>

<section id="projects-cta" class="scroll-mt-24">
  <app-projects-cta></app-projects-cta>
</section>


